//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

export function create(dto: Types.CreateDataBlockFieldDto, config?: AxiosRequestConfig | undefined): Promise<Types.DataBlockFieldDto> {
    let url_ = getBaseUrl() + "/api/data-blocks/fields";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateDataBlockFieldDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreate(_response);
    });
}

function processCreate(response: AxiosResponse): Promise<Types.DataBlockFieldDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDataBlockFieldDto(resultData200);
        return Promise.resolve<Types.DataBlockFieldDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DataBlockFieldDto>(null as any);
}

export function get(dataBlockTypeId?: number | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.DataBlockFieldDto[]> {
    let url_ = getBaseUrl() + "/api/data-blocks/fields?";
    if (dataBlockTypeId !== undefined && dataBlockTypeId !== null)
        url_ += "DataBlockTypeId=" + encodeURIComponent("" + dataBlockTypeId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGet?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGet(_response);
    });
}

function processGet(response: AxiosResponse): Promise<Types.DataBlockFieldDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initDataBlockFieldDto(item)
              );
            }
        return Promise.resolve<Types.DataBlockFieldDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DataBlockFieldDto[]>(null as any);
}

export function getById(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.DataBlockFieldDto> {
    let url_ = getBaseUrl() + "/api/data-blocks/fields/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetById,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetById?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetById(_response);
    });
}

function processGetById(response: AxiosResponse): Promise<Types.DataBlockFieldDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDataBlockFieldDto(resultData200);
        return Promise.resolve<Types.DataBlockFieldDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DataBlockFieldDto>(null as any);
}

export function patch(id: number, dto: Types.PatchDataBlockFieldDto, config?: AxiosRequestConfig | undefined): Promise<Types.DataBlockFieldDto> {
    let url_ = getBaseUrl() + "/api/data-blocks/fields/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePatchDataBlockFieldDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatch,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPatch?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatch(_response);
    });
}

function processPatch(response: AxiosResponse): Promise<Types.DataBlockFieldDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDataBlockFieldDto(resultData200);
        return Promise.resolve<Types.DataBlockFieldDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DataBlockFieldDto>(null as any);
}

export function remove(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/data-blocks/fields/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemove,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemove?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemove(_response);
    });
}

function processRemove(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function getById2(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.DataBlockFieldDto> {
    let url_ = getBaseUrl() + "/api/data-blocks/fields/by-id/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetById2,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetById2?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetById2(_response);
    });
}

function processGetById2(response: AxiosResponse): Promise<Types.DataBlockFieldDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDataBlockFieldDto(resultData200);
        return Promise.resolve<Types.DataBlockFieldDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DataBlockFieldDto>(null as any);
}

export function renameField(id: number, dto: Types.RenameDataBlockFieldDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/data-blocks/fields/{id}/name";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeRenameDataBlockFieldDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigRenameField,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigRenameField?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRenameField(_response);
    });
}

function processRenameField(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Returns all existing values for dataBlockFieldId.
If field is a table, returns all values of a dto.TableColumn.TableColumn
 * @param tableColumn (optional) 
 * @param tableRowFilter_ColumnName (optional) 
 * @param tableRowFilter_ColumnValue (optional) 
 */
export function getExistingValues(dataBlockFieldId: number, tableColumn?: string | null | undefined, tableRowFilter_ColumnName?: string | null | undefined, tableRowFilter_ColumnValue?: string | null | undefined, config?: AxiosRequestConfig | undefined): Promise<string[]> {
    let url_ = getBaseUrl() + "/api/data-blocks/fields/{dataBlockFieldId}/values?";
    if (dataBlockFieldId === undefined || dataBlockFieldId === null)
      throw new Error("The parameter 'dataBlockFieldId' must be defined.");
    url_ = url_.replace("{dataBlockFieldId}", encodeURIComponent("" + dataBlockFieldId));
    if (tableColumn !== undefined && tableColumn !== null)
        url_ += "TableColumn=" + encodeURIComponent("" + tableColumn) + "&";
    if (tableRowFilter_ColumnName !== undefined && tableRowFilter_ColumnName !== null)
        url_ += "TableRowFilter.ColumnName=" + encodeURIComponent("" + tableRowFilter_ColumnName) + "&";
    if (tableRowFilter_ColumnValue !== undefined && tableRowFilter_ColumnValue !== null)
        url_ += "TableRowFilter.ColumnValue=" + encodeURIComponent("" + tableRowFilter_ColumnValue) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetExistingValues,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetExistingValues?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetExistingValues(_response);
    });
}

function processGetExistingValues(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = resultData200;
        return Promise.resolve<string[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
}

export function getDataBlockFieldsForEditing(dataBlockTypeId: number, config?: AxiosRequestConfig | undefined): Promise<Types.DataBlockFieldListDto[]> {
    let url_ = getBaseUrl() + "/api/data-blocks/fields/edit/{dataBlockTypeId}";
    if (dataBlockTypeId === undefined || dataBlockTypeId === null)
      throw new Error("The parameter 'dataBlockTypeId' must be defined.");
    url_ = url_.replace("{dataBlockTypeId}", encodeURIComponent("" + dataBlockTypeId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDataBlockFieldsForEditing,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetDataBlockFieldsForEditing?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDataBlockFieldsForEditing(_response);
    });
}

function processGetDataBlockFieldsForEditing(response: AxiosResponse): Promise<Types.DataBlockFieldListDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initDataBlockFieldListDto(item)
              );
            }
        return Promise.resolve<Types.DataBlockFieldListDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DataBlockFieldListDto[]>(null as any);
}

/**
 * Limited patch which allows editing only IsOptionAllowed and IsBasedOnPrevious.
(User Story 73314: [Change Request]: Edit UI permissions allow to enable the option "based on previous")
 */
export function patchLimited(id: number, dto: Types.PatchDataBlockFieldDto, config?: AxiosRequestConfig | undefined): Promise<Types.DataBlockFieldDto> {
    let url_ = getBaseUrl() + "/api/data-blocks/fields/{id}/limited";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePatchDataBlockFieldDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchLimited,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPatchLimited?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchLimited(_response);
    });
}

function processPatchLimited(response: AxiosResponse): Promise<Types.DataBlockFieldDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDataBlockFieldDto(resultData200);
        return Promise.resolve<Types.DataBlockFieldDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DataBlockFieldDto>(null as any);
}

export function convertFieldToDictionary(id: number, dto: Types.ConvertFieldToDictionaryDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/data-blocks/fields/{id}/convert-to-dictionary";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeConvertFieldToDictionaryDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigConvertFieldToDictionary,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigConvertFieldToDictionary?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processConvertFieldToDictionary(_response);
    });
}

function processConvertFieldToDictionary(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Used for Dictionary fields with custom option, when converting them to Dictionary without option.
Method converts all existing Custom values to regular Dictionary Items
 */
export function createDictionaryItemsFromCustomValues(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/data-blocks/fields/{id}/convert-custom-values-to-dictionary-items";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateDictionaryItemsFromCustomValues,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigCreateDictionaryItemsFromCustomValues?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateDictionaryItemsFromCustomValues(_response);
    });
}

function processCreateDictionaryItemsFromCustomValues(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigCreate: Partial<AxiosRequestConfig> | null;
export function getCreateRequestConfig() {
  return _requestConfigCreate;
}
export function setCreateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreate = value;
}
export function patchCreateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreate = patch(_requestConfigCreate ?? {});
}

let _requestConfigGet: Partial<AxiosRequestConfig> | null;
export function getGetRequestConfig() {
  return _requestConfigGet;
}
export function setGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGet = value;
}
export function patchGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGet = patch(_requestConfigGet ?? {});
}

let _requestConfigGetById: Partial<AxiosRequestConfig> | null;
export function getGetByIdRequestConfig() {
  return _requestConfigGetById;
}
export function setGetByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetById = value;
}
export function patchGetByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetById = patch(_requestConfigGetById ?? {});
}

let _requestConfigPatch: Partial<AxiosRequestConfig> | null;
export function getPatchRequestConfig() {
  return _requestConfigPatch;
}
export function setPatchRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatch = value;
}
export function patchPatchRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatch = patch(_requestConfigPatch ?? {});
}

let _requestConfigRemove: Partial<AxiosRequestConfig> | null;
export function getRemoveRequestConfig() {
  return _requestConfigRemove;
}
export function setRemoveRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemove = value;
}
export function patchRemoveRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemove = patch(_requestConfigRemove ?? {});
}

let _requestConfigGetById2: Partial<AxiosRequestConfig> | null;
export function getGetById2RequestConfig() {
  return _requestConfigGetById2;
}
export function setGetById2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetById2 = value;
}
export function patchGetById2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetById2 = patch(_requestConfigGetById2 ?? {});
}

let _requestConfigRenameField: Partial<AxiosRequestConfig> | null;
export function getRenameFieldRequestConfig() {
  return _requestConfigRenameField;
}
export function setRenameFieldRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRenameField = value;
}
export function patchRenameFieldRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRenameField = patch(_requestConfigRenameField ?? {});
}

let _requestConfigGetExistingValues: Partial<AxiosRequestConfig> | null;
export function getGetExistingValuesRequestConfig() {
  return _requestConfigGetExistingValues;
}
export function setGetExistingValuesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetExistingValues = value;
}
export function patchGetExistingValuesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetExistingValues = patch(_requestConfigGetExistingValues ?? {});
}

let _requestConfigGetDataBlockFieldsForEditing: Partial<AxiosRequestConfig> | null;
export function getGetDataBlockFieldsForEditingRequestConfig() {
  return _requestConfigGetDataBlockFieldsForEditing;
}
export function setGetDataBlockFieldsForEditingRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDataBlockFieldsForEditing = value;
}
export function patchGetDataBlockFieldsForEditingRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDataBlockFieldsForEditing = patch(_requestConfigGetDataBlockFieldsForEditing ?? {});
}

let _requestConfigPatchLimited: Partial<AxiosRequestConfig> | null;
export function getPatchLimitedRequestConfig() {
  return _requestConfigPatchLimited;
}
export function setPatchLimitedRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchLimited = value;
}
export function patchPatchLimitedRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchLimited = patch(_requestConfigPatchLimited ?? {});
}

let _requestConfigConvertFieldToDictionary: Partial<AxiosRequestConfig> | null;
export function getConvertFieldToDictionaryRequestConfig() {
  return _requestConfigConvertFieldToDictionary;
}
export function setConvertFieldToDictionaryRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigConvertFieldToDictionary = value;
}
export function patchConvertFieldToDictionaryRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigConvertFieldToDictionary = patch(_requestConfigConvertFieldToDictionary ?? {});
}

let _requestConfigCreateDictionaryItemsFromCustomValues: Partial<AxiosRequestConfig> | null;
export function getCreateDictionaryItemsFromCustomValuesRequestConfig() {
  return _requestConfigCreateDictionaryItemsFromCustomValues;
}
export function setCreateDictionaryItemsFromCustomValuesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateDictionaryItemsFromCustomValues = value;
}
export function patchCreateDictionaryItemsFromCustomValuesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateDictionaryItemsFromCustomValues = patch(_requestConfigCreateDictionaryItemsFromCustomValues ?? {});
}